import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import SatuanPendidikanService from "../../services/SatuanPendidikanService";
import {message} from "antd";

export const initialState = {
    loading: false,
    dataSp: [],
    dataSpByIDKota:[],
    showMessage:false,
    message:''
}


export const getDataSekolahByIDKota = createAsyncThunk('ref/sekolahbyidkota',async (data, { rejectWithValue }) => {
    const {token,id}=data;
    try {
        const response = await SatuanPendidikanService.getDataByIDKota(token,id)
        //console.log(JSON.stringify(response))
        return response;
    } catch (err) {
        message.error(err.response?.data?.message || 'Error',3)
    }
})


export const satuanPendidikanSlice = createSlice({
    name: 'satuan_pendidikan',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataSekolahByIDKota.fulfilled, (state, action) => {
                state.loading = false
                state.dataSpByIDKota = action.payload
            })
            .addCase(getDataSekolahByIDKota.pending, (state) => {
                state.loading = true
            })
            .addCase(getDataSekolahByIDKota.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
                state.dataSpByIDKota = action.payload
            })
    },
})

export const {
    showDataSuccess,
    showLoading
} = satuanPendidikanSlice.actions

export default satuanPendidikanSlice.reducer
